/* GENERATED FILE — do not edit.
   Source: shared-ui/ui/Btn.js
   Run "node shared-ui/sync.js" after editing the source. */
import React from 'react';

/**
 * variant: "default" | "accent"
 * Emits .btn-ui (never Bootstrap's .btn — see ui.css).
 * Every other prop (type, onClick, disabled, aria-*) passes straight through.
 */
export default function Btn({ variant = 'default', children, className, type, ...rest }) {
  const classes = ['btn-ui'];
  if (variant === 'accent') classes.push('btn-accent');
  if (className) classes.push(className);

  return (
    <button type={type || 'button'} className={classes.join(' ')} {...rest}>
      {children}
    </button>
  );
}
